import { gql } from 'graphql-request'

export const UPDATE_USER_TASK_SPECTATOR_RESCUED = gql`
  mutation UPDATE_USER_TASK_SPECTATOR_RESCUED($userTaskSpectatorId: Int!) {
    updateUserTaskSpectatorRescued(userTaskSpectatorId: $userTaskSpectatorId) {
      error
      status
      data {
        dateRescued
        userTaskBonusType
        value
        itemPackage {
          id
          name
          # name
          # imgItem
          # itemTypeBuy
          # durationInDay
          # valueItem
          # itemType
        }
      }
    }
  }
`
